import { render } from "./index.vue?vue&type=template&id=ad6974dc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script